export default __webpack_public_path__ + "4bfa009d95d74869684bfc2b7d77c8e2.png";